import api from "./api";

export const bankDetailService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/bank-details", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/bank-details/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(bankDetailData) {
    try {
      const response = await api.post("/bank-details", bankDetailData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, bankDetailData) {
    try {
      const response = await api.put(`/bank-details/${id}`, bankDetailData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/bank-details/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getStats() {
    try {
      const response = await api.get("/bank-details/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default bankDetailService;
